import { useEffect, useRef } from "react";
import "./style.scss";

const WaiterSuccessModal = ({ open, onClose, tr = (s) => s }) => {
  const overlayRef = useRef(null);

  useEffect(() => {
    const onKey = (e) => {
      if (e.key === "Escape") onClose?.();
    };
    if (open) document.addEventListener("keydown", onKey);
    return () => document.removeEventListener("keydown", onKey);
  }, [open, onClose]);

  if (!open) return null;

  return (
    <div
      className="waiter-success-modal__overlay"
      ref={overlayRef}
      onClick={(e) => {
        if (e.target === overlayRef.current) onClose?.();
      }}
    >
      <div className="waiter-success-modal__sheet">
        <div className="waiter-success-modal__icon">
          <i className="fas fa-check-circle"></i>
        </div>
        <h3 className="waiter-success-modal__title">
          {tr("Спасибо за ваше обращение!")}
        </h3>
        <p className="waiter-success-modal__message">
          {tr("Официант получил ваш запрос и скоро подойдет к вашему столу. Пожалуйста, подождите немного.")}
        </p>
        <button className="waiter-success-modal__button" onClick={onClose}>
          {tr("Понятно")}
        </button>
      </div>
    </div>
  );
};

export default WaiterSuccessModal;

